import React, { Component } from 'react';
import { connect } from 'formik';
import { IPreferencesProps, IOuterProps } from '../../models/components/preferences';
import { SelectNoneAsync } from '../../components/input/select/main';
import {
    SortableContainer,
    SortableElement,
} from 'react-sortable-hoc';
import arrayMove from 'array-move';
import { HomeIndexBoxType } from '../../models/enums/HomeIndexBoxType';
import Switch from 'react-switch';
import Translator from '../../core/i18n';
import { UserType } from '../../models/pages/login.d';
import { Log } from 'ng2-logger';
import { ModuleItems } from '../../models/enums/moduleItems';

const T = Translator.create();
const _logger = Log.create('User Preferences');
const SortableList = SortableContainer(({ children }: any) => {
    return <div className="col-6 question-list" style={{ padding: 0 }}>{children}</div>;
});

export class Preferences extends Component<IPreferencesProps> {
    state = {
        boxItems: ['0', '1', '2', '3', '4', '5', '6', '7', '8'],
        boxCount: [{ value: 2, label: '2' }, { value: 3, label: '3' }],
        dateFormat: [{ value: 'DD.MM.YYYY', label: 'DD.MM.YYYY' }, { value: 'MM.DD.YYYY', label: 'MM.DD.YYYY' }],
        boxVisualRadio: true,
        boxItemsVisual: [false, false, false, false, false, false, false, false]
    };

    public SortableItem = SortableElement(({ value }: any) => (
        <div style={{ background: 'transparent' }} className="question-row">
            <div className="tick-radio position-relative" style={{ width: "unset" }}>
                <input
                    id={'home.index.boxvisual'}
                    type="checkbox"
                    name={'boxVisualRadio'}
                    // tslint:disable-next-line:jsx-no-lambda
                    onChange={e => this.handleInputChange(e, value)}
                    value={1}
                    checked={this.state.boxItemsVisual[value]}
                    style={{ verticalAlign: 'middle' }}
                    className="form-radio"
                />
                <span style={{ marginInlineStart: '8px' }}>{this.equalsType(value)}</span>
            </div>
        </div>
    ));

    handleInputChange = (event: any, setValue: any) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.state.boxItemsVisual[setValue] = value;
        this.setState({ boxItemsVisual: this.state.boxItemsVisual });

        this.saveBoxes();
    }

    equalsType = (value: any) => {
        switch (value) {
            case HomeIndexBoxType.Activity:
                return T.t('r_home_index_box_activity');
            case HomeIndexBoxType.Announcement:
                return T.t('r_home_index_box_announcement');
            case HomeIndexBoxType.Forum:
                return T.t('r_home_index_box_forum');
            case HomeIndexBoxType.Grade:
                return T.t('r_home_index_box_grade');
            case HomeIndexBoxType.Message:
                return T.t('r_home_index_box_message');
            case HomeIndexBoxType.VirtualClass:
                return T.t('r_home_index_box_virtual_class');
            case HomeIndexBoxType.Exam:
                return T.t('r_home_index_box_exam');
            case HomeIndexBoxType.Assignment:
                return T.t('r_home_index_box_assignment');
            case HomeIndexBoxType.Survey:
                return T.t('r_home_index_box_survey');
        }
    }

    onSortEnd = ({ oldIndex, newIndex }: any) => {
        if (oldIndex !== newIndex) {
            this.setState(({ boxItems }: any) => ({
                boxItems: arrayMove(boxItems, oldIndex, newIndex),
            }));
        }

        this.saveBoxes();
    };

    saveBoxes = () => {
        setTimeout(() => {
            const boxAllowed: string[] = [];
            this.state.boxItems.forEach(item => {
                boxAllowed.push(item);
            });

            this.state.boxItems.forEach(item => {
                if (!this.state.boxItemsVisual[parseInt(item, 10)]) {
                    boxAllowed.splice(boxAllowed.indexOf(item), 1);
                }
            });

            this.props.formik.values.handleChange('home.index.boxallowed', boxAllowed.toString());
        }, 1000);
    }

    componentWillMount() {
        if (this.props.formik.values.userPreferences.length > 0) {
            this.props.formik.values.userPreferences.forEach(preference => {
                if (preference.name === 'home.index.boxvisual') {
                    this.state.boxVisualRadio = preference.value === 'true' ? true : false;
                }

                if (preference.name === 'home.index.boxallowed') {
                    if (preference.value) {
                        this.state.boxItems = preference.value.split(',');
                        this.state.boxItems.forEach(item => {
                            this.state.boxItemsVisual[parseInt(item, 10)] = true;
                        });
                    }
                }

                if (preference.name === 'home.index.boxcount') {
                    this.props.formik.values.boxCount = parseInt(preference.value, 10);
                }

                if (preference.name === 'application.dateformat') {
                    this.props.formik.values.dateFormat = preference.value;
                }
            });
        } else {
            this.setState({
                boxItemsVisual: [true, true, true, true, true, true, true, true],
                boxVisualRadio: true
            });
        }
    }

    componentDidMount() {
        const items = ['0', '1', '2', '3', '4', '5', '6', '7', '8'];

        items.forEach(item => {
            if (!this.state.boxItems.includes(item)) { this.state.boxItems.push(item); }
        });

        if (this.props.formik.values.userType === UserType.Teacher) {
            this.state.boxItems.splice(this.state.boxItems.indexOf('2'), 1);
            this.state.boxItems.splice(this.state.boxItems.indexOf('1'), 1);
        }

        if (!this.props.formik.values.moduleItems?.includes(ModuleItems.Forum) && this.state.boxItems.includes('4')) {
            this.state.boxItems.splice(this.state.boxItems.indexOf('4'), 1);
        }

    }

    onChangeSwitch = (checked: any, event: any, id: any) => {
        this.state.boxVisualRadio = checked;
        this.props.formik.values.handleChangeSwitch(checked, event, id);
    }

    onChangeSelect = (event: any, name: any) => {
        this.props.formik.values.handleChange(name, event ? event.value : null);
    }

    public render() {
        const { boxItems } = this.state;
        const { boxCount } = this.state;

        return (
            <div className="send-notification">
                {
                    (this.props.formik.values.userType !== UserType.Admin &&
                        this.props.formik.values.userType !== UserType.SuperAdmin &&
                        this.props.formik.values.userType !== UserType.ProgramAdmin) &&
                    <>
                        <label className="input-label">{T.t('r_preferences_home_page')}</label>

                        <div className="small-switch mb-4">
                            <label className="switch">
                                <Switch
                                    id={'home.index.boxvisual'}
                                    name={'boxVisualRadio'}
                                    onChange={this.onChangeSwitch}
                                    checked={this.state.boxVisualRadio}
                                    checkedIcon={false}
                                    uncheckedIcon={false}
                                    onColor="#319b6b"
                                    className="react-switch react-switch-margin"
                                    height={20}
                                    width={38}
                                />
                            </label>
                            <span>{T.t('r_preferences_index_box_show')}</span>
                        </div>
                        <h5 className="mb-3">{T.t('r_preferences_index_box_order')}</h5>
                        <div className="mb-3 d-flex align-items-end sortable-list">
                            <SortableList disabled={true} onSortEnd={this.onSortEnd}>
                                {boxItems.map((value, index) => {
                                    return <this.SortableItem key={`item-${value}`} index={index} value={parseInt(value, 10)} />;
                                })}
                            </SortableList>
                        </div>

                        <label className="input-label">{T.t('r_preferences_index_box_count')}</label>
                        <div className="d-flex align-items-end mb-3 mt-2">
                            <div className="k365-input" style={{ animationDuration: '0.3s', display: 'block', minWidth: 220, alignItems: 'middle' }}>
                                <SelectNoneAsync
                                    name={'home.index.boxcount'}
                                    className='k365-select'
                                    setFieldValue={this.props.formik.setFieldValue}
                                    setOptions={boxCount}
                                    onChange={this.onChangeSelect}
                                    isTouched={this.props.formik.setFieldTouched}
                                    setSelectValue={this.props.formik.values.boxCount && typeof this.props.formik.values.boxCount === 'number' ? [this.props.formik.values.boxCount] : ''}
                                    placeHolder={T.t('r_make_select')}
                                />
                            </div>
                        </div>
                    </>
                }

                <label className='input-label'>{T.t('r_preferences_application_date_format')}</label>
                <div className="d-flex align-items-end mb-3 mt-2">
                    <div className="k365-input" style={{ animationDuration: '0.3s', display: 'block', minWidth: 220, alignItems: 'middle' }}>
                        <SelectNoneAsync
                            name={'application.dateformat'}
                            setFieldValue={this.props.formik.setFieldValue}
                            className='k365-select'
                            setOptions={this.state.dateFormat}
                            onChange={this.onChangeSelect}
                            isTouched={this.props.formik.setFieldTouched}
                            setSelectValue={this.props.formik.values.dateFormat ? [this.props.formik.values.dateFormat] : ''}
                            placeHolder={T.t('r_make_select')}
                        />
                    </div>
                </div>
            </div >
        );
    }
}

export default connect<{}, IOuterProps>(Preferences);
